import { useAtomValue } from 'jotai';
import pdpSelectedProtectionPlanIdAtom from './pdpSelectedProtectionPlanIdAtom';
const usePdpSelectedProtectionPlanId = () => {
  const pdpSelectedProtectionPlanId = useAtomValue(pdpSelectedProtectionPlanIdAtom);
  return pdpSelectedProtectionPlanId;
};
export default usePdpSelectedProtectionPlanId;